export const VueLogo = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
      <path fill="#61B083" d="M14.75 2.063 12 6.875 9.25 2.062H0l12 20.813L24 2.062h-9.25Z" />
      <path fill="#364659" d="M14.75 2.063 12 6.875 9.25 2.062H4.812L12 14.563l7.188-12.5H14.75Z" />
    </svg>
  );
};
